"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverclaimSearchStore = exports.OVERCLAIM_SEARCH_DEFAULT_FILTERS = exports.defaultOverclaimPagination = void 0;
const get_search_query_1 = require("@App/helpers/get-search-query");
const search_option_type_1 = require("@App/enum/search-option-type");
const required_criteria_1 = require("@App/enum/required-criteria");
const mobx_1 = require("mobx");
const lodash_1 = require("lodash");
const find_page_on_limit_change_1 = require("@App/helpers/pagination/find-page-on-limit-change");
const calc_num_pages_1 = require("@App/helpers/pagination/calc-num-pages");
const search_1 = require("@App/api/routes/search");
const overclaim_1 = require("@App/api/routes/overclaim");
const overclaim_search_criteria_store_1 = __importDefault(require("@App/stores/overclaim/overclaim-search-criteria-store"));
const generate_search_criterion_1 = require("@App/helpers/generate-search-criterion");
const overclaimAPI = __importStar(require("@App/api/routes/overclaim"));
exports.defaultOverclaimPagination = {
    page: 1,
    limit: 10,
};
const defaultOverclaimSelectionCriteria = [
    (0, generate_search_criterion_1.generateSearchCriterionFromOption)(get_search_query_1.SEARCH_OVERCLAIM_WORK_OPTIONS[0], true),
];
exports.OVERCLAIM_SEARCH_DEFAULT_FILTERS = { sort: 'overclaim_creation_date' };
class OverclaimSearchStore {
    createOverclaimCriteriaStore() {
        const maxCriteria = 3;
        return new overclaim_search_criteria_store_1.default(defaultOverclaimSelectionCriteria, get_search_query_1.SEARCH_OVERCLAIM_WORK_OPTIONS, search_option_type_1.SearchOptionType.primary, required_criteria_1.RequiredCriteria.none, maxCriteria, this.rootStore.rightsholderStore);
    }
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksRightsHolder", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_worksRightsHolderPaginationInfo", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_pagination", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.defaultOverclaimPagination
        });
        Object.defineProperty(this, "_overclaimSelectionQuery", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_currentSearchFilters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: exports.OVERCLAIM_SEARCH_DEFAULT_FILTERS
        });
        Object.defineProperty(this, "_overclaimStatusCounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_isOverclaimBulkActionStarted", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "_overclaimsSelectedForBulkAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, "searchForWorks", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (callBackPagination) => __awaiter(this, void 0, void 0, function* () {
                if (callBackPagination) {
                    let paginationWithSort = Object.assign({}, callBackPagination);
                    if (this._currentSearchFilters.sort && this._currentSearchFilters.sort.length > 0) {
                        paginationWithSort = Object.assign(Object.assign({}, paginationWithSort), { sort: [
                                { field: this._currentSearchFilters.sort, direction: 'DESC' },
                                { field: '_id', direction: 'DESC' },
                            ] });
                    }
                    (0, mobx_1.runInAction)(() => {
                        this._pagination = paginationWithSort;
                    });
                }
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const _a = this._currentSearchFilters, { sort: _unused } = _a, filtersWithoutSort = __rest(_a, ["sort"]);
                const finalSelectionQuery = Object.assign(Object.assign({}, this._overclaimSelectionQuery), filtersWithoutSort);
                yield this.getWorksRightsHolder(this.rootStore.rightsholderStore.currentRightsholderId, this._pagination, finalSelectionQuery);
                const page = this._pagination.page ? this._pagination.page : 1;
                this.setCurrentPaginationPage(page);
            })
        });
        Object.defineProperty(this, "setupOverclaimStatusCounts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const searchResponse = yield (0, overclaim_1.getOverclaimStatusCounts)(this.rootStore.rightsholderStore.currentRightsholderId);
                this._overclaimStatusCounts = searchResponse.data;
            })
        });
        Object.defineProperty(this, "changeSearchResultsLimit", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newLimit) => {
                const newPage = (0, find_page_on_limit_change_1.findPageOnLimitChange)(this._pagination, this._worksRightsHolder ? this._worksRightsHolder.count : 1, newLimit);
                const pagination = {
                    page: newPage,
                    limit: newLimit,
                };
                return pagination;
            }
        });
        Object.defineProperty(this, "submitBulkRelinquishment", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => __awaiter(this, void 0, void 0, function* () {
                const promises = Array.from(this._overclaimsSelectedForBulkAction).map((overclaimHeaderId) => overclaimAPI.createOverclaimRelinquishment(this.rootStore.rightsholderStore.currentRightsholderId, overclaimHeaderId));
                const results = yield Promise.allSettled(promises);
                results.forEach((result, index) => {
                    if (result.status === 'rejected') {
                        this.rootStore.popupStore.setAlertFromError(result.reason);
                    }
                });
                (0, mobx_1.runInAction)(() => {
                    this._isOverclaimBulkActionStarted = false;
                });
            })
        });
        (0, mobx_1.makeObservable)(this, {
            _worksRightsHolder: mobx_1.observable,
            _worksRightsHolderPaginationInfo: mobx_1.observable,
            _pagination: mobx_1.observable,
            _currentSearchFilters: mobx_1.observable,
            isDefaultPagination: mobx_1.computed,
            destroyOverclaimCriteria: mobx_1.action,
            _overclaimStatusCounts: mobx_1.observable,
            _isOverclaimBulkActionStarted: mobx_1.observable,
            _overclaimsSelectedForBulkAction: mobx_1.observable,
            setIsOverclaimBulkActionStarted: mobx_1.action,
            setCurrentSearchFilters: mobx_1.action,
            setCurrentPaginationLimit: mobx_1.action,
            setCurrentPaginationPage: mobx_1.action,
            changeSearchResultsLimit: mobx_1.action,
            toggleOverclaimSelectionForBulkAction: mobx_1.action,
            addMultipleToBulkActionSelection: mobx_1.action,
            resetOverclaimSelectionForBulkAction: mobx_1.action,
        });
        this.rootStore = rootStore;
    }
    get pagination() {
        return this._pagination;
    }
    get limit() {
        var _a;
        return (_a = this._pagination.limit) !== null && _a !== void 0 ? _a : 10;
    }
    get isDefaultPagination() {
        return (0, lodash_1.isEqual)(this._pagination, exports.defaultOverclaimPagination);
    }
    get worksRightsHolder() {
        return this._worksRightsHolder;
    }
    get worksRightsHolderPaginationInfo() {
        return this._worksRightsHolderPaginationInfo;
    }
    get overclaimStatusCounts() {
        return this._overclaimStatusCounts;
    }
    get overclaimSearchQuery() {
        return this._overclaimSelectionQuery;
    }
    get isOverclaimBulkActionStarted() {
        return this._isOverclaimBulkActionStarted;
    }
    get overclaimsSelectedForBulkAction() {
        return this._overclaimsSelectedForBulkAction;
    }
    setCurrentSearchFilters(filters) {
        this._currentSearchFilters = filters;
    }
    setCurrentPaginationLimit(limit) {
        this._pagination.limit = limit;
    }
    setCurrentPaginationPage(page) {
        this._pagination.page = page;
    }
    setOverclaimSelectionSearchQuery(overclaimSelectionQuery) {
        this._overclaimSelectionQuery = overclaimSelectionQuery;
    }
    setIsOverclaimBulkActionStarted(bulkActionStatus) {
        this._isOverclaimBulkActionStarted = bulkActionStatus;
    }
    toggleOverclaimSelectionForBulkAction(overclaimHeaderId) {
        if (overclaimHeaderId) {
            if (this._overclaimsSelectedForBulkAction.has(overclaimHeaderId)) {
                this._overclaimsSelectedForBulkAction.delete(overclaimHeaderId);
            }
            else {
                this._overclaimsSelectedForBulkAction.add(overclaimHeaderId);
            }
        }
    }
    addMultipleToBulkActionSelection(overclaimHeaderIdList) {
        this._overclaimsSelectedForBulkAction = new Set([
            ...this._overclaimsSelectedForBulkAction,
            ...overclaimHeaderIdList,
        ]);
    }
    getWorksRightsHolder(rightsHolderId, pagination, search) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const searchResponse = yield (0, search_1.searchOverclaimsRH)(rightsHolderId, pagination, search);
                const response = {
                    count: searchResponse.data.totalElements,
                    works: searchResponse.data.content,
                    error: undefined,
                };
                (0, mobx_1.runInAction)(() => {
                    this._worksRightsHolder = response;
                    if (pagination.limit && pagination.page && response) {
                        const data = (0, calc_num_pages_1.calcNumPages)(response.count, pagination.limit, pagination.page);
                        if (!data) {
                            return;
                        }
                        this._worksRightsHolderPaginationInfo = data;
                    }
                });
            }
            catch (e) {
                this.rootStore.popupStore.setAlertFromError(e);
            }
        });
    }
    destroyOverclaimCriteria() {
        this._pagination = exports.defaultOverclaimPagination;
        this._overclaimSelectionQuery = {};
        this._worksRightsHolder = undefined;
        this._worksRightsHolderPaginationInfo = undefined;
        this._overclaimStatusCounts = undefined;
        this._currentSearchFilters = exports.OVERCLAIM_SEARCH_DEFAULT_FILTERS;
        this._isOverclaimBulkActionStarted = false;
    }
    resetOverclaimSelectionForBulkAction() {
        this._overclaimsSelectedForBulkAction = new Set();
    }
}
exports.OverclaimSearchStore = OverclaimSearchStore;
